<template>
  <div>
    <div class="initial-class--content animation-bottom animation-delay-02" style="padding-top: 40px;">

      <div class="initial-class--content__header container column align-items-center justify-content-center">
        <div class="initial-class--content__header__icon animation-top animation-delay-05">
          <img src="@/assets/img/video-heart.svg" width="60" alt="Minds">
        </div>
        <div class="initial-class--content__header__text container wrap align-items-center justify-content-center animation-bottom animation-delay-1">
          <span style="font-weight: 100;">BEM VINDO A</span>&nbsp<span style="font-weight: 300;">AULA INICIAL</span>
        </div>
      </div>

      <div class="initial-class--content__block container column align-items-center justify-content-center">
        <div class="initial-class--content__block_text animation-top animation-delay-1">
          <p>
            Seja bem vindo a <strong>Minds English School</strong>. Aqui você assistirá o video de introdução a metodologia de nossa escola! Após assistir o video entre em contato com sua unidade para marcar a <strong>Unit One</strong>!
          </p>
        </div>

        <div class="initial-class--content__block_video animation-fade animation-delay-1 relative">
          <transition name="btn-transition">
              <div>
                <img src="@/assets/img/video-play.svg"  alt="Minds" class="animation-fade initial-class--content__block_video_btnplay" @click="play()" v-if="!isPlaying">
                <div class="initial-class--content__block_video_btnbg" @click="play()" v-if="!isPlaying"/>
              </div>
          </transition>
          <video ref="video"
                 src="@/assets/media/initialClass.mp4"
                 :poster="require('@/assets/img/exercicies/words-attack/intro.png')"
                 @playing="isPlaying = true"
                 @pause="isPlaying = false"
                 @loadeddata="loaded = true"
                 @click="$event.target.pause()">
          </video>
        </div>
        <div class="container wrap justify-content-center">
          <button
            style="width: 275px; height: 42px; padding: 0; margin: 5px;"
            class="btn btn-lg btn-blue gradient-blue btn-full btn-rounded animation-bottom animation-delay-25 margin-top-10"
            @click="$store.commit('setShowPdf', true)"
          >
            Files
          </button>
          <button
            style="width: 275px; height: 42px; padding: 0; margin: 5px;"
            class="btn btn-lg btn-yellow gradient-yellow btn-full btn-rounded animation-bottom animation-delay-25 margin-top-10"
            @click="$router.go(-1)"
          >
            Go back
          </button>
        </div>
      </div>

    </div>
    <modalPdf/>
  </div>
</template>

<script>
import modalPdf from '@/components/modal/modalPdf'

export default {
  data () {
    return {
      isPlaying: false,
    }
  },
  components: {
    modalPdf
  },
  methods: {
    play () {
      if (this.loaded)
        this.$refs['video'].play()
    }
  },
  mounted () {
    this.$refs['video'].load()
  }
}
</script>

<style media="screen" lang="scss" scoped>
.initial-class--content {
  width: 980px;
  max-width: 90%;
  margin: 0 auto 20px;
  padding: 10px;
  .initial-class--content__header {
    min-height: 140px;
    background-color: #EFEFEF;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    .initial-class--content__header__text {
      color: #255F83;
      font-size: 29px;
      font-weight: 300;
      line-height: 39px;
      font-weight: 100;
      margin-left: 10px;
      margin-right: 10px;
      text-transform: uppercase;
      .strong {
        font-weight: 900;
        margin-left: 7px;
      }
    }
  }
  .initial-class--content__block {
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));
    background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);
    border-radius: 0 0 10px 10px;
    padding: 20px;
    box-sizing: border-box;
    .initial-class--content__block_message {
      color: #fff;
      font-weight: 200;
      margin-right: 10px;
      margin-bottom: 10px;
      border: 1px solid #fff;
      padding: 10px;
      border-radius: 100px;
    }
    .initial-class--content__block_input {
      margin: 0px 10px 0px 0px;
      input{
        text-align: center;
        font-weight: 300 !important;
        font-family: 'Volte', sans-serif;
        color: #00b1a2;
        &::placeholder,
        &:focus,
        &:focus-within,
        &:visited,
        &:active {
          color: #656565;
          font-weight: 300 !important;
          opacity: 1;
          border: none;
          font-family: 'Volte', sans-serif;
          text-align: center;
          }
      }
    }
    .initial-class--content__block_btn {
      // margin: 0px 0px 0px 10px;
    }
    .initial-class--content__block_box {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
    }
    .initial-class--content__block_text {
      color: #fff;
      width: 700px;
      max-width: 90%;
      text-align: center;
      margin-bottom: 20px;
      font-size: 14px;
      padding: 0px 30px;
      p{
        font-weight: 200;
        font-size: 17px;
      }
    }
    .initial-class--content__block_video {
      // background: #D8D8D8;
      // background: #C50737;
      width: 684px;
      // background-image: url("../../assets/img/videoinicialposter.jpg");
      padding: 10px;
      background-size: cover;
      max-width: 90%;
      overflow: hidden;
      min-height: 387px;
      border-radius: 10px;
      .initial-class--content__block_video_btnplay {
        width: 103px;
        transition: ease-in .1s;
        position: absolute;
        top: calc(50% - 40px);
        left: calc(50% - 40px);
        cursor: pointer;
        z-index: 100;
        &:hover{
          width: 115px;
          margin: -6px;
        }
      }
      .initial-class--content__block_video_btnbg {
        width: 127px;
        height: 127px;
        background: white;
        border-radius: 300px;
        position: absolute;
        opacity: .7;
        top: calc(50% - 52px);
        left: calc(50% - 52px);
        transition: ease-in .1s;
      }
      // img {
      //   cursor: pointer;
      //   position: absolute;
      //   top: calc(50% - 30px);
      //   left: calc(50% - 30px);
      //   z-index: 100;
      // }
      video {
        cursor: pointer;
        border-radius: 10px;
        max-width: 100%;
        max-height: calc(100% + 10px);
        min-width: 100%;
        min-height: calc(100% + 10px);
      }
      @media screen and (max-width: 480px) {
        min-height: 200px;
      }
    }
  }
}

.btn-transition {
  &-enter-active,
  &-leave-active {
    transition: opacity .2s;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/initialClass/index.vue